import { type ParsedUrlQuery } from 'querystring';

import { extractBase36Id } from '@/utils';

export const eventQueryParams = (query: ParsedUrlQuery) => {
  const eventWithSameTeamsId = extractBase36Id(query.event);
  const sport = query.sport;

  if (!eventWithSameTeamsId || typeof sport !== 'string') {
    throw new Error('url is malformed');
  }

  const forceEventId = !query.e ? undefined : Number(query.e);

  return { eventWithSameTeamsId, forceEventId, sport };
};
